import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";
import RegisterForm from "components/Forms/RegisterForm";
import { useAuthStore } from "stores/auth/authStore";
import { useNavigate } from "react-router-dom";
import Modal from "components/Modal";

export const RegisterModal = () => {
  const navigate = useNavigate();
  const current = useModalStore((s) => s.current);
  const close = useModalStore((s) => s.close);
  const toggleRegisterPassword = useAuthStore(action => action.toggleRegisterPassword);
  const toggleRepeatPassword = useAuthStore(action => action.toggleRepeatPassword);

  const isOpen = current === ModalKey.Register;

  return (
    <Modal
      isCloseIcon
      title={"Welcome"}
      shouldCloseOnOverlayClick={false}
      modalIsOpen={isOpen}
      className="signup-modal-content"
      closeModal={() => {
        if (window.history?.state?.idx === 0) {
          navigate("/");
        } else {
          navigate(-1);
        }
        close();
        toggleRegisterPassword();
        toggleRepeatPassword();
      }}
    >
      {{
        content: <RegisterForm />,
      }}
    </Modal>
  );
};

export default RegisterModal;
